/**
 * Helper funkcija za čitanje userType iz tenantConnections
 * Prvo proverava tenantConnections za selectedTenantId, pa falls back na user.userType
 */
export const getUserTypeFromConnections = (user, selectedTenantId = null) => {
  // Prvo proveri tenantConnections ako postoje i ako je selectedTenantId prosleđen
  if (selectedTenantId && user?.tenantConnections && user.tenantConnections.length > 0) {
    const connection = user.tenantConnections.find(
      tc => {
        const tenantId = tc.tenantId?._id || tc.tenantId;
        return tenantId === selectedTenantId;
      }
    );
    
    if (connection?.userType) {
      return connection.userType;
    }
  }

  // Ako nema tenantConnections ili selectedTenantId, ali ima prvi connection, koristi ga
  if (user?.tenantConnections && user.tenantConnections.length > 0) {
    const firstConnection = user.tenantConnections[0];
    if (firstConnection?.userType) {
      return firstConnection.userType;
    }
  }

  // Falls back na user.userType ako postoji
  if (user?.userType) {
    return user.userType;
  }

  return undefined;
};

/**
 * Helper funkcija za proveru da li je korisnik customer
 */
export const isCustomer = (user, selectedTenantId = null) => {
  const userType = getUserTypeFromConnections(user, selectedTenantId);
  // Ako nema userType (undefined), tretiraj kao customera
  if (!userType) return true;
  return userType === 'customer';
};

/**
 * Helper funkcija za proveru da li je korisnik tenant_admin
 */
export const isTenantAdmin = (user, selectedTenantId = null) => {
  const userType = getUserTypeFromConnections(user, selectedTenantId);
  return userType === 'tenant_admin';
};

/**
 * Helper funkcija za proveru da li je korisnik employee
 */
export const isEmployee = (user, selectedTenantId = null) => {
  const userType = getUserTypeFromConnections(user, selectedTenantId);
  return userType === 'employee';
};

/**
 * Helper funkcija za proveru da li je korisnik super_admin
 */
export const isSuperAdmin = (user) => {
  // Super admin ima userType direktno na user objektu
  return user?.userType === 'super_admin';
};

const userHelper = {
  getUserTypeFromConnections,
  isCustomer,
  isTenantAdmin,
  isEmployee,
  isSuperAdmin
};

export default userHelper;

